import { window } from "../window";

/**
 * Calculates the cumulative transformations applied to an element and its ancestors.
 */

const getCumulativeTransformations = (
  element: HTMLElement | null = null
): { transformX: number; transformY: number } => {
  let transformX = 0;
  let transformY = 0;
  let workingElement: HTMLElement | null = element;

  if (workingElement) {
    do {
      workingElement = workingElement.parentNode as HTMLElement | null;

      if (workingElement) {
        try {
          const computedStyle = window.getComputedStyle(workingElement);
          const transform = computedStyle.getPropertyValue("transform");

          if (transform.includes("matrix(")) {
            transformX += Number.parseInt(transform.split(",")[4]);
            transformY += Number.parseInt(transform.split(",")[5]);
          }
          // eslint-disable-next-line no-empty
        } catch {}
      }
    } while (workingElement);
  }

  return { transformX, transformY };
};

export { getCumulativeTransformations };
